// src/components/LogosFooter.jsx
import React from 'react';
import { Row, Col } from 'antd';
import logoARN from '../../assets/logos/Banner_Logos_FRES.png';

import './LogosFooter.css'; // Archivo CSS para estilos

const LogosFooter = () => {
    return (
        <div className="logos-footer">
            <Row gutter={[32, 32]} justify="center" align="middle">
                <Col xs={12} sm={12} md={12} lg={12}>
                    <a href="https://www.reincorporacion.gov.co/es" target="_blank" rel="noopener noreferrer">
                        <img src={logoARN} alt="ARN Logo" className="logo-image" />
                    </a>
                </Col>
            </Row>
        </div>
    );
};

export default LogosFooter;